import PropTypes from 'prop-types'
import React, { Component } from 'react'

import { GOODS_TYPES } from 'constants/sales'
import CartSaleWideContainer from 'containers/CartSaleWideContainer'
import DistributionBannerContainer from 'containers/DistributionBannerContainer'
import { LocalizationContext } from 'contexts/Localization'
import { LastBlock } from 'styles/components/layout'
import { UK, US } from 'constants/countries'

import BResultsBacteria from './components/BResultsBacteria'
import BResultsChanges from './components/BResultsChanges'
import BResultsFirst from './components/BResultsFirst'
import BResultsHealth from './components/BResultsHealth'
import BResultsNutrition from './components/BResultsNutrition'
import BResultsRecommendations from './components/BResultsRecommendations'
import BResultsDemo from './components/BResultsDemo'
import { OrderTestWidget } from 'widgets/OrderTestWidget'

class BiomeResults extends Component {
  static propTypes = {
    pathCdn: PropTypes.string.isRequired,
    texts: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props)
    this.secondBlock = React.createRef()
  }

  render() {
    const { texts, pathCdn } = this.props
    const { specialDistribution } = this.context
    const { locale } = this.context
    this.isUK = locale === UK
    this.isUS = locale === US
    return (
      <>
        <BResultsFirst data={texts.first} secondBlockRef={this.secondBlock} />

        {this.isUK || this.isUS && (
          <BResultsDemo
            texts={{ title: texts.video_title, body: texts.video_body }}
          />
        )}
        {!specialDistribution && (
          <div ref={this.secondBlock} className="pt-4">
            <BResultsHealth data={texts.health} pathCdn={pathCdn} />
          </div>
        )}

        <div className="pt-6">
          {specialDistribution && <div ref={this.secondBlock} />}
          <BResultsNutrition data={texts.nutrition} pathCdn={pathCdn} />
        </div>
        <div className="pt-6">
          <BResultsBacteria data={texts.bacteria} pathCdn={pathCdn} />
        </div>
        <div className="pt-6 pb-md-6">
          <BResultsChanges data={texts.changes} pathCdn={pathCdn} />
        </div>

        {this.isUS && <BResultsRecommendations className="pt-6 pb-md-6" data={texts.changes} pathCdn={pathCdn} />}

        {this.isUS ? (
          <OrderTestWidget
            className='py-md-6'
            productType={GOODS_TYPES.biome}
            commonTexts={this.texts}
          />
        ) : (
          <LastBlock>
            <CartSaleWideContainer
              className="pt-6"
              productType={GOODS_TYPES.biome}
            />
            <DistributionBannerContainer />
          </LastBlock>
        )}
      </>
    )
  }
}

BiomeResults.contextType = LocalizationContext

export default BiomeResults
